import React, { useState, useEffect } from 'react';  
import axios from 'axios';  
import { BACKEND_BASE_URL } from '../../config.js';  
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, CircularProgress, Box, Chip } from '@material-ui/core';  
import { Pagination } from '@mui/material'; 

function formatDetail(log) {
    const summary = log.result_summary;
    if (log.traceback) {
        const firstLine = String(log.traceback).split('\n').filter(Boolean).slice(-1)[0];
        return firstLine || 'See traceback';
    }
    if (!summary || typeof summary !== 'object') {
        if (summary && summary.scraped !== undefined) return summary.scraped;
        return summary?.total_scraped || summary || '—';
    }
    const videoId = summary.video_id || '';
    const chars = summary.char_count != null ? `${summary.char_count} chars` : '';
    const message = summary.message || '';
    return [videoId, chars, message].filter(Boolean).join(' · ') || '—';
}

export default function CeleryLogsTable() {  
    const [logs, setLogs] = useState([]);  
    const [loading, setLoading] = useState(true);  
    const [page, setPage] = useState(1);  
    const [totalPages, setTotalPages] = useState(1);
    const [count, setCount] = useState(0);

    useEffect(() => { 
        setLoading(true); 
        axios.get(`${BACKEND_BASE_URL}/api/celery-logs/?page=${page}`).then(res => { 
            setLogs(res.data.results || res.data);  
            setCount(res.data.count || 0);
            setTotalPages(Math.ceil((res.data.count || res.data.length || 0) / 25) || 1); 
            setLoading(false);  
        }).catch(err => { 
            setLoading(false);  
        });  
    }, [page]); 

    return (  
        <Paper style={{ marginTop: '20px', padding: '15px' }}> 
            <Typography variant='h6' gutterBottom>
                Webshare Proxy & Transcript Logs
            </Typography>
            <Typography variant='body2' color='textSecondary' style={{ marginBottom: 12 }}>
                Shows both <strong>Manual</strong> (Regenerate from video / Apify) and <strong>Celery</strong> (Webshare / scrape) runs. Total: {count}
            </Typography>
            <TableContainer><Table size='small'> 
                <TableHead>
                    <TableRow>
                        <TableCell>Task ID</TableCell>
                        <TableCell>Job Type</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Date Done</TableCell>
                        <TableCell>Detail</TableCell>
                    </TableRow>
                </TableHead>  
                <TableBody> 
                    {loading ? (
                        <TableRow>
                            <TableCell colSpan={5} align='center'><CircularProgress/></TableCell>
                        </TableRow>
                    ) : logs.length === 0 ? (
                        <TableRow>
                            <TableCell colSpan={5} align='center'>No transcript jobs logged yet.</TableCell>
                        </TableRow>
                    ) : logs.map((log) => ( 
                        <TableRow key={log.id}> 
                            <TableCell>{(log.id || '').slice(0, 8)}...</TableCell> 
                            <TableCell>{log.job_type || (log.task_name || '').split('.').pop() || 'Unknown'}</TableCell> 
                            <TableCell>
                                <Chip
                                    label={log.status}
                                    style={{
                                        backgroundColor: log.status === 'SUCCESS' ? '#4caf50' : log.status === 'FAILURE' ? '#f44336' : '#ffeb3b',
                                        color: '#fff',
                                    }}
                                    size='small'
                                />
                            </TableCell> 
                            <TableCell>{log.date_done ? new Date(log.date_done).toLocaleString() : '—'}</TableCell> 
                            <TableCell style={{ maxWidth: 420, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                {formatDetail(log)}
                            </TableCell> 
                        </TableRow> 
                    ))}  
                </TableBody>
            </Table></TableContainer> 
            {!loading && totalPages > 1 && ( 
                <Box display='flex' justifyContent='center' mt={2}> 
                    <Pagination count={totalPages} page={page} onChange={(e, val) => setPage(val)} color='primary' />  
                </Box>  
            )} 
        </Paper>  
    );  
} 
